import RpcService from "@/core/services/Rpc/RpcService";
import RpcResponse from "@/core/services/Rpc/RpcResponse";

class EdiOperatorsDAO {

    static async getList(): Promise<RpcResponse> {
        return await RpcService.makeRequest('ediOperators.getList');
    }
}

export default EdiOperatorsDAO;
